import{ PuntajePruebasDTO } from '../model/adaptive.puntaje.pruebas.dto';

export class AdaptativePuntajeDTO {
    constructor(
        public idItem: string,
        public auditoria: string,
        public puntaje: PuntajePruebasDTO[],
        public codigo: string
    ){}
}